import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';

import { ContractService } from '../../../../../services/contract.service';
import { AccountService } from '../../../../../services/account.service';
import { NgForm, NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { AddContract } from '../../../../../models/AddContract';
import { AdminService } from '../../../../../services/Admin.service';
import { ConfirmationPageFailComponent } from '../../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
/*tslint:disable:max-line-length */
import { ConfirmationPageSuccessComponent } from '../../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
/*tslint:enable:max-line-length */
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../../shared-components/busy-indicator/busy-indicator.component';


@Component({
  selector: 'app-addcontract',
  templateUrl: './addcontract.component.html',
  styleUrls: ['./addcontract.component.scss']
})
export class AddcontractComponent implements OnDestroy, OnInit {
  @Output()
  closeModel: EventEmitter<any> = new EventEmitter(); //creating an output event
  addContract: AddContract = new AddContract();
  passwordConfirm: Boolean;
  ErrorMessage: string;
  successMsg: string;
  _router: Router;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  alive = true;
  @ViewChild('frmAddContract') frmAddContract: NgForm;

  constructor(private adminService: AdminService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private contractService: ContractService) {
    this._router = router;
  }

  ngOnInit() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }
  goToMyContract(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.ErrorMessage = null;
    this.addContract = new AddContract();
    this.closeModel.emit(null);
    // window.close();
  }

  close(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  public checkPassword(frmAddContract: NgForm) {
    this.adminService.CheckPassword(this.addContract.Password)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.passwordConfirm = false;
          frmAddContract.controls['addContract.Password'].setErrors(null);
        },
        err => {
          this.passwordConfirm = true;
          frmAddContract.controls['addContract.Password'].setErrors({ 'incorrect': true });
        }
      );
  }
  public addNewContract() {
    this.spinner.show();
    this.successMsg = null;
    this.ErrorMessage = null;
    this.contractService.addNewcontract(this.addContract)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.spinner.hide();
          console.log(data);
          if (data.Result.indexOf('Fail') > -1) {
            this.showSuccessConfirmation = false;
            this.showFailConfirmation = true;
            this.ErrorMessage = data.Result;
          } else {
            this.showSuccessConfirmation = true;
            this.showFailConfirmation = false;
            this.successMsg = data.Result;
            this.addContract = new AddContract();
            this.refreshContractList();
          }
        },
        err => {
          this.spinner.hide();
          console.log('addcontract', err);
          this.showFailConfirmation = true;
          this.successMsg = null;
          this.ErrorMessage = err._body;
        }

      );
  }

  refreshContractList() {
    this.contractService.getContractList()
      .takeWhile(() => this.alive)
      .subscribe(
        contracts => {
          console.log('refreshContractList done.');
        },
        err => {
          console.log('refreshContractList error!');
        }
      );
  }

  clearData() {
    this.addContract = new AddContract();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
    this.ErrorMessage = null;
  }

  ngOnDestroy() {
    this.alive = false;
  }

}





// WEBPACK FOOTER //
// ./src/app/pages/client/my-contracts/contract/addcontract/addcontract.component.ts